import Block from '../block'

export default class Theme extends Block {
	static title = 'theme'

	constructor($el) {
		super($el)

		this.detailInner = this.$el.findElement('detail-inner')
		this.toggleMobile = this.$el.findElement('toggle-mobile')
		this.toggleTablet = this.$el.findElement('toggle-tablet')
		this.toggleDesktop = this.$el.findElement('toggle-desktop')

		this.toggleMobile.on('click', () => {
			this.toggleTablet.removeClass('theme__toggle--active')
			this.toggleDesktop.removeClass('theme__toggle--active')
			this.toggleMobile.addClass('theme__toggle--active')
			this.detailInner.attr('class', 'theme__detail theme__detail--mobile')
		})

		this.toggleTablet.on('click', () => {
			this.toggleTablet.addClass('theme__toggle--active')
			this.toggleDesktop.removeClass('theme__toggle--active')
			this.toggleMobile.removeClass('theme__toggle--active')
			this.detailInner.attr('class', 'theme__detail theme__detail--tablet')
		})

		this.toggleDesktop.on('click', () => {
			this.toggleTablet.removeClass('theme__toggle--active')
			this.toggleDesktop.addClass('theme__toggle--active')
			this.toggleMobile.removeClass('theme__toggle--active')
			this.detailInner.attr('class', 'theme__detail theme__detail--desktop')
		})

		$(window).on('resize', () => {
			if ($(window).width() <= 1030) {
				this.toggleTablet.removeClass('theme__toggle--active')
				this.toggleDesktop.addClass('theme__toggle--active')
				this.toggleMobile.removeClass('theme__toggle--active')
				this.detailInner.attr('class', 'theme__detail theme__detail--desktop')
			}
		})
	}
}
